import { useContext, createContext } from 'react';

export const AuthUserContext = createContext(null);

export const useAppUserContext = () => useContext(AuthUserContext);

export const VideoContext = createContext(null);

export const useVideoContext = () => useContext(VideoContext);